import AssignmentProgress from '../api/assignmentProgress';
import { applicationApiExecute, applicationSave, applicationFetchAll } from './applicationActions';

export const startAssignmentProgress = applicationApiExecute(AssignmentProgress.start);
export const submitAssignmentProgress = applicationApiExecute(AssignmentProgress.submit);
export const gradeAssignmentProgress = applicationApiExecute(AssignmentProgress.grade);
export const saveAssignmentProgress = applicationSave(AssignmentProgress);
export const allowResubmission = applicationApiExecute(AssignmentProgress.allowResubmission);
export const fetchAssignmentProgresses = applicationFetchAll(AssignmentProgress);
